(function() { module.exports = window["wp"]["element"]; }());